export default function initAccordion(): void {
  Alpine.data('accordion', () => ({
    open: -1 as number,

    init() {
      // All items start closed
      this.open = -1;
    },

    toggle(index: number) {
      // If clicking the already open item, close it
      if (this.open === index) {
        this.open = -1;
      } else {
        // Otherwise, open this item (closes the previous one automatically)
        this.open = index;
      }
    },
  }));
}
